export function handleTransitionError(err) {
  // NOTE: this means we're redirected again which is fine to ignore
  if (err.message !== 'TransitionAborted') {
    throw err;
  }
}
